document.addEventListener('DOMContentLoaded', function () {
  // Load all registered sections on the page.
  load('*');
});
function load(types, containers) {
  
  equalizeSite();
  window.addEventListener('resize', function() {
        equalizeSite();
  }, true);



}
function equalizeSite() {
		// Found an issue with this script when a browser is zooming in/out so we disable it on zoom.
		//var zoom = detectZoom.zoom();
		//if(zoom != 1) return;

		// Break Points: These are what you have setup in the _settings.scss
		// The actual points where it converts from mobile to tablet and tablet to desktop.
		// Sometimes there is not a tablet design in this case simply set it to the same as the desktop.
		var $bptablet = 500;

		// Designed Sizes: These sizes are referencing what you are using to design the site e.g. PSD, AI etc.
		// This is what you have your media queries set to. Remember you only need 1 set of styles for each device this
		// script will handle the rest.
		var $mobile = 428;

		// Initial Font Size: This is based on what the common copy font size is for each design.
		var $fsmobile = 16,
			$fstablet = 16,
			$fsdesktop = 16;

      var $ww = window.innerWidth;

      if($ww < $bptablet) {
          // mobile
          var fontsize = $fsmobile * ($ww/$mobile);
          console.log(document.querySelector('html'))
          document.querySelector('html').style.fontSize = fontsize + "px";
      } else {
          // desktop
          document.querySelector('html').style.fontSize = $fsdesktop + "px";
      }
}
